// @flow

import React, { PureComponent } from 'react';
import cx from 'classnames';
import 'client/styles/check.scss';

type Props = {
  ariaLabel?: string,
  checked: string | boolean,
  className?: string,
  clickHandler?: Function,
  id?: string | null,
  size?: string,
  style?: Object,
};

class Checkmark extends PureComponent<Props> {
  static defaultProps = {
    ariaLabel: 'checkmark',
    className: '',
    clickHandler: () => {},
    size: '2rem',
    style: {},
    id: null,
  };

  render() {
    const { ariaLabel, checked, id, style, className, clickHandler, size } = this.props;
    return (
      <button
        id={id}
        aria-label={ariaLabel}
        className={cx(className, { checked }, 'checkmark-toggle')}
        onClick={clickHandler}
        type="button"
        style={{
          ...style,
          fontSize: size,
        }}>
        <div className="radio-button radio-with-white-background no-margin unchecked-state" />
        <div className="checked-bg-container">
          <div className="checked-bg" />
        </div>
        <div className="check-container">
          <div className="icon-ok-bold white-color check no-margin" />
        </div>
      </button>
    );
  }
}

export default Checkmark;
